export default __webpack_public_path__ + "static/media/dreamstime_s_143818783.f8050016.jpg";